(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-assistance-autocomplete"] && !Shopify.designMode) return;
  try {
    
  const initPowernetAddressAutocomplete = () => {
    document.querySelectorAll('[data-pnw-assistance-coverage]').forEach((panel) => {
      const input = panel.querySelector('[data-pnw-coverage-address]');
      if (!input || input.dataset.pnwAutocompleteBound === 'true') return;

      input.dataset.pnwAutocompleteBound = 'true';
      input.setAttribute('autocomplete', 'shipping street-address');
      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-expanded', 'false');
      input.placeholder = 'Inizia a digitare via, numero civico e comune';

      const status = panel.querySelector('[data-pnw-coverage-status]');
      const shell = document.createElement('div');
      shell.className = 'pnw-assistance-autocomplete-shell';
      input.parentNode.insertBefore(shell, input);
      shell.appendChild(input);

      const list = document.createElement('div');
      list.className = 'pnw-assistance-autocomplete-list';
      list.id = `PnwAddressSuggestions-${Math.random().toString(36).slice(2, 9)}`;
      list.setAttribute('role', 'listbox');
      list.hidden = true;
      shell.appendChild(list);
      input.setAttribute('aria-controls', list.id);

      let timer = null;
      let controller = null;
      let results = [];
      let activeIndex = -1;

      const cleanName = (value = '') =>
        value.replace(/,\s*(Italia|Italy)\s*$/i, '').trim();

      const cityName = (address = {}) =>
        address.city || address.town || address.village || address.municipality || address.county || '';

      const displayParts = (place) => {
        const address = place.address || {};
        const road = address.road || address.pedestrian || address.footway || address.hamlet || '';
        const number = address.house_number || '';
        const primary = [road, number].filter(Boolean).join(' ').trim() || cleanName(place.display_name).split(',')[0];
        const secondary = [address.postcode, cityName(address), address.state].filter(Boolean).join(' - ');
        return { primary, secondary };
      };

      const close = () => {
        list.hidden = true;
        list.innerHTML = '';
        results = [];
        activeIndex = -1;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
      };

      const setActive = (index) => {
        if (!results.length) return;
        activeIndex = (index + results.length) % results.length;
        list.querySelectorAll('[data-pnw-address-suggestion]').forEach((button, buttonIndex) => {
          const active = buttonIndex === activeIndex;
          button.classList.toggle('is-active', active);
          if (active) {
            input.setAttribute('aria-activedescendant', button.id);
            button.scrollIntoView({ block: 'nearest' });
          }
        });
      };

      const choose = (index) => {
        const place = results[index];
        if (!place) return;
        input.value = cleanName(place.display_name);
        input.dataset.pnwAutocompleteSelected = input.value;
        close();
        if (status) {
          status.textContent = 'Indirizzo selezionato. Clicca Verifica copertura per controllare i 15 km.';
          status.className = 'pnw-assistance-coverage__status is-neutral';
        }
        input.focus();
      };

      const render = (places, message = '') => {
        list.innerHTML = '';
        results = places;
        activeIndex = -1;

        if (!places.length) {
          const row = document.createElement('div');
          row.className = 'pnw-assistance-autocomplete-message';
          row.textContent = message;
          list.appendChild(row);
          list.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          return;
        }

        places.forEach((place, index) => {
          const parts = displayParts(place);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pnw-assistance-autocomplete-item';
          button.dataset.pnwAddressSuggestion = 'true';
          button.id = `${list.id}-${index}`;
          button.setAttribute('role', 'option');

          const icon = document.createElement('span');
          icon.className = 'pnw-assistance-autocomplete-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><path d="M12 22s7-6.1 7-13a7 7 0 1 0-14 0c0 6.9 7 13 7 13Z"/><circle cx="12" cy="9" r="2.5"/></svg>';

          const copy = document.createElement('span');
          copy.className = 'pnw-assistance-autocomplete-copy';
          const strong = document.createElement('strong');
          strong.textContent = parts.primary;
          const small = document.createElement('small');
          small.textContent = parts.secondary || cleanName(place.display_name);
          copy.append(strong, small);
          button.append(icon, copy);
          button.addEventListener('mousedown', (event) => event.preventDefault());
          button.addEventListener('click', () => choose(index));
          list.appendChild(button);
        });

        list.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        setActive(0);
      };

      const search = async (term) => {
        controller?.abort();
        controller = new AbortController();
        render([], 'Cerco indirizzi...');

        const url = new URL('https://nominatim.openstreetmap.org/search');
        url.searchParams.set('format', 'jsonv2');
        url.searchParams.set('addressdetails', '1');
        url.searchParams.set('limit', '5');
        url.searchParams.set('countrycodes', 'it');
        url.searchParams.set('accept-language', 'it');
        url.searchParams.set('email', 'info@powernetsrl.it');
        url.searchParams.set('q', `${term}, Sicilia, Italia`);

        try {
          const response = await fetch(url.toString(), {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('autocomplete_unavailable');
          const places = await response.json();
          if (input.value.trim() !== term) return;
          render(Array.isArray(places) ? places : [], 'Nessun indirizzo trovato. Aggiungi numero civico o comune.');
        } catch (error) {
          if (error?.name !== 'AbortError') close();
        }
      };

      const schedule = () => {
        window.clearTimeout(timer);
        const term = input.value.trim();
        if (term.length < 4) {
          controller?.abort();
          close();
          return;
        }
        timer = window.setTimeout(() => search(term), 800);
      };

      input.addEventListener('input', () => {
        delete input.dataset.pnwAutocompleteSelected;
        schedule();
      });

      input.addEventListener('focus', schedule);

      input.addEventListener('keydown', (event) => {
        const open = !list.hidden && results.length > 0;
        if (event.key === 'ArrowDown' && open) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActive(activeIndex + 1);
          return;
        }
        if (event.key === 'ArrowUp' && open) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setActive(activeIndex - 1);
          return;
        }
        if (event.key === 'Enter' && open && activeIndex >= 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          choose(activeIndex);
          return;
        }
        if (event.key === 'Escape' && !list.hidden) {
          event.preventDefault();
          event.stopImmediatePropagation();
          close();
        }
      }, true);

      document.addEventListener('click', (event) => {
        if (!shell.contains(event.target)) close();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPowernetAddressAutocomplete, { once: true });
  } else {
    initPowernetAddressAutocomplete();
  }

  document.addEventListener('shopify:section:load', initPowernetAddressAutocomplete);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-assistance-coverage"] && !Shopify.designMode) return;
  try {
    
  const radians = (degrees) => degrees * Math.PI / 180;

  const haversineKm = (lat1, lon1, lat2, lon2) => {
    const earthRadiusKm = 6371;
    const dLat = radians(lat2 - lat1);
    const dLon = radians(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(radians(lat1)) *
        Math.cos(radians(lat2)) *
        Math.sin(dLon / 2) ** 2;
    return 2 * earthRadiusKm * Math.asin(Math.sqrt(a));
  };

  const initPowernetAssistanceCoverage = () => {
    document.querySelectorAll('[data-pnw-assistance-coverage]').forEach((panel) => {
      if (panel.dataset.pnwCoverageBound === 'true') return;

      const form = document.querySelector('form[data-pnw-product-form]');
      if (!form) return;

      const buyRow = form.querySelector('.pnw-product-buyrow');
      if (buyRow && panel.parentElement !== form) {
        form.insertBefore(panel, buyRow);
      }

      panel.dataset.pnwCoverageBound = 'true';

      const addressInput = panel.querySelector('[data-pnw-coverage-address]');
      const verifyButton = panel.querySelector('[data-pnw-coverage-verify]');
      const status = panel.querySelector('[data-pnw-coverage-status]');
      const submitButton = form.querySelector('[data-pnw-product-submit], [name="add"], button[type="submit"]');
      const variantSelect = form.querySelector('[data-pnw-variant-select]');
      const propRaw = form.querySelector('[data-pnw-property-raw-address]');
      const propAddress = form.querySelector('[data-pnw-property-address]');
      const propDistance = form.querySelector('[data-pnw-property-distance]');
      const propCoverage = form.querySelector('[data-pnw-property-coverage]');

      const originLat = Number(panel.dataset.originLat);
      const originLon = Number(panel.dataset.originLon);
      const maxDistanceKm = Number(panel.dataset.maxDistance || 15);
      let verified = false;

      const selectedVariantAvailable = () => {
        if (!variantSelect) return true;
        const option = variantSelect.options[variantSelect.selectedIndex];
        return option?.dataset.available === 'true';
      };

      const setStatus = (message, type = 'neutral') => {
        if (!status) return;
        status.textContent = message;
        status.className = `pnw-assistance-coverage__status is-${type}`;
      };

      const clearProperties = () => {
        [propRaw, propAddress, propDistance, propCoverage].forEach((input) => {
          if (!input) return;
          input.value = '';
          input.disabled = true;
        });
      };

      const lockPurchase = () => {
        verified = false;
        form.dataset.pnwCoverageVerified = 'false';
        form.classList.add('pnw-assistance-coverage-locked');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-disabled', 'true');
        }
      };

      const unlockPurchase = () => {
        verified = true;
        form.dataset.pnwCoverageVerified = 'true';
        form.classList.remove('pnw-assistance-coverage-locked');
        if (submitButton) {
          const available = selectedVariantAvailable();
          submitButton.disabled = !available;
          submitButton.setAttribute('aria-disabled', String(!available));
        }
      };

      const geocodeAddress = async (rawAddress) => {
        const url = new URL('https://nominatim.openstreetmap.org/search');
        url.searchParams.set('format', 'jsonv2');
        url.searchParams.set('addressdetails', '1');
        url.searchParams.set('limit', '5');
        url.searchParams.set('countrycodes', 'it');
        url.searchParams.set('accept-language', 'it');
        url.searchParams.set('email', 'info@powernetsrl.it');
        url.searchParams.set('q', `${rawAddress}, Sicilia, Italia`);

        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('geocode_unavailable');

        const results = await response.json();
        if (!Array.isArray(results) || !results.length) {
          throw new Error('address_not_found');
        }

        const candidates = results
          .map((result) => ({
            ...result,
            latNumber: Number(result.lat),
            lonNumber: Number(result.lon)
          }))
          .filter((result) =>
            Number.isFinite(result.latNumber) && Number.isFinite(result.lonNumber)
          );

        if (!candidates.length) throw new Error('address_not_found');

        candidates.sort((a, b) =>
          haversineKm(originLat, originLon, a.latNumber, a.lonNumber) -
          haversineKm(originLat, originLon, b.latNumber, b.lonNumber)
        );

        return candidates[0];
      };

      const roadDistanceKm = async (latitude, longitude) => {
        const url = `https://router.project-osrm.org/route/v1/driving/${originLon},${originLat};${longitude},${latitude}?overview=false&alternatives=false&steps=false`;
        const response = await fetch(url, {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('route_unavailable');

        const data = await response.json();
        const metres = Number(data?.routes?.[0]?.distance);
        if (data?.code !== 'Ok' || !Number.isFinite(metres)) {
          throw new Error('route_unavailable');
        }

        return metres / 1000;
      };

      const verifyCoverage = async () => {
        const rawAddress = addressInput?.value.trim() || '';
        clearProperties();
        lockPurchase();

        if (rawAddress.length < 8) {
          setStatus('Inserisci via, numero civico e comune per effettuare la verifica.', 'error');
          addressInput?.focus();
          return;
        }

        const originalLabel = verifyButton?.textContent || 'Verifica copertura';
        if (verifyButton) {
          verifyButton.disabled = true;
          verifyButton.textContent = 'Verifica…';
        }
        setStatus('Sto verificando indirizzo e distanza dalla sede Powernet…');

        try {
          const place = await geocodeAddress(rawAddress);
          const distance = await roadDistanceKm(place.latNumber, place.lonNumber);
          const distanceLabel = `${distance.toFixed(1)} km su strada`;
          const resolvedAddress = place.display_name || rawAddress;

          if (distance <= maxDistanceKm) {
            if (propRaw) {
              propRaw.value = rawAddress;
              propRaw.disabled = false;
            }
            if (propAddress) {
              propAddress.value = resolvedAddress;
              propAddress.disabled = false;
            }
            if (propDistance) {
              propDistance.value = distanceLabel;
              propDistance.disabled = false;
            }
            if (propCoverage) {
              propCoverage.value = 'Verificata entro 15 km';
              propCoverage.disabled = false;
            }

            unlockPurchase();
            setStatus(`Copertura disponibile: ${distanceLabel}. Puoi procedere con l'acquisto.`, 'success');
          } else {
            setStatus(
              `Indirizzo fuori copertura: ${distanceLabel}. Il servizio di ritiro è disponibile fino a 15 km dalla sede Powernet.`,
              'error'
            );
          }
        } catch (error) {
          if (error?.message === 'address_not_found') {
            setStatus(
              'Indirizzo non trovato. Inserisci via, numero civico, comune e, se possibile, CAP.',
              'error'
            );
          } else {
            setStatus(
              'Non è stato possibile verificare la distanza in questo momento. Riprova tra poco.',
              'error'
            );
          }
        } finally {
          if (verifyButton) {
            verifyButton.disabled = false;
            verifyButton.textContent = originalLabel;
          }
        }
      };

      clearProperties();
      lockPurchase();

      window.setTimeout(() => {
        if (!verified) lockPurchase();
      }, 500);

      addressInput?.addEventListener('input', () => {
        clearProperties();
        lockPurchase();
        setStatus('Indirizzo modificato: ripeti la verifica prima di acquistare.');
      });

      addressInput?.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        verifyCoverage();
      });

      verifyButton?.addEventListener('click', verifyCoverage);

      form.addEventListener(
        'submit',
        (event) => {
          if (verified && form.dataset.pnwCoverageVerified === 'true') return;
          event.preventDefault();
          event.stopImmediatePropagation();
          setStatus(
            'Prima di acquistare devi verificare un indirizzo di ritiro entro 15 km.',
            'error'
          );
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          window.setTimeout(() => addressInput?.focus(), 250);
        },
        true
      );
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPowernetAssistanceCoverage, { once: true });
  } else {
    initPowernetAssistanceCoverage();
  }

  document.addEventListener('shopify:section:load', initPowernetAssistanceCoverage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-cart-vat-summary"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=()=>{
    const source=document.querySelector('[data-pnw-cart-vat-summary]');
    const flow=document.querySelector('[data-pnw-vat-flow]');
    if(!source||!flow||flow.dataset.pnwFiscalReady==='true')return;
    flow.dataset.pnwFiscalReady='true';

    const select=flow.querySelector('[data-pnw-vat-select]');
    const oldSubtotal=flow.querySelector('.pnw-cart-summary__row .pnw-cart-summary__total')?.closest('.pnw-cart-summary__row');
    const vatChoice=flow.querySelector('.pnw-vat-choice');
    if(!select||!vatChoice)return;

    select.name='attributes[Regime IVA richiesto]';
    const saved=source.dataset.savedRegime;
    if(['22','10','reverse'].includes(saved))select.value=saved;

    if(oldSubtotal)oldSubtotal.hidden=true;

    const summary=document.createElement('div');
    summary.className='pnw-fiscal-summary';
    summary.innerHTML='<div class="pnw-fiscal-summary__row"><span>Imponibile</span><strong data-pnw-net></strong></div><div class="pnw-fiscal-summary__row"><span data-pnw-vat-label>IVA 22%</span><strong data-pnw-vat></strong></div><div class="pnw-fiscal-summary__row pnw-fiscal-summary__row--total"><span>Totale</span><strong data-pnw-fiscal-total></strong></div><p class="pnw-fiscal-summary__note" data-pnw-fiscal-note></p>';
    vatChoice.insertAdjacentElement('beforebegin',summary);

    const totalGross=Number(source.dataset.cartTotalCents||0);
    const currency=source.dataset.cartCurrency||'EUR';
    const fmt=(cents)=>new Intl.NumberFormat('it-IT',{style:'currency',currency,minimumFractionDigits:2}).format(cents/100);
    const net=Math.round(totalGross/1.22);

    const render=()=>{
      const regime=select.value;
      let vatRate=22;
      if(regime==='10')vatRate=10;
      if(regime==='reverse')vatRate=0;
      const vat=Math.round(net*vatRate/100);
      const total=net+vat;
      summary.querySelector('[data-pnw-net]').textContent=fmt(net);
      summary.querySelector('[data-pnw-vat-label]').textContent=vatRate===0?'IVA 0% - Reverse charge':`IVA ${vatRate}%`;
      summary.querySelector('[data-pnw-vat]').textContent=fmt(vat);
      summary.querySelector('[data-pnw-fiscal-total]').textContent=fmt(total);
      const note=summary.querySelector('[data-pnw-fiscal-note]');
      if(regime==='22')note.textContent='Importi calcolati sul regime IVA standard attualmente applicato allo store.';
      if(regime==='10')note.textContent='Importo IVA 10% calcolato sullo stesso imponibile. L’applicazione effettiva resta soggetta a verifica fiscale Powernet.';
      if(regime==='reverse')note.textContent='Importo senza IVA calcolato sullo stesso imponibile. Il Reverse charge resta soggetto a verifica fiscale Powernet.';
    };

    const persist=()=>fetch('/cart/update.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({attributes:{'Regime IVA richiesto':select.value}})
    }).catch(()=>{});

    select.addEventListener('change',()=>{render();persist()});
    render();
    source.remove();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-partner-logos-helper"]) return;
  try {
    
(function(){function addUploadedPartners(){var rail=document.querySelector('.pnw-brand-rail');var template=document.querySelector('[data-pnw-uploaded-partners-template]');if(!rail||!template||rail.querySelector('[data-pnw-uploaded-partner]'))return;rail.appendChild(template.content.cloneNode(true));}if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',addUploadedPartners,{once:true});}else{addUploadedPartners();}document.addEventListener('shopify:section:load',addUploadedPartners);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-product-addons"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (amountInCents, currency) => {
      const locale = document.documentElement.lang || 'it-IT';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(amountInCents / 100);
    };

    const setupPanel = (panel) => {
      if (!(panel instanceof HTMLElement) || panel.dataset.pnwAddonReady === 'true') return;

      const scope = document.querySelector('[data-pnw-product-scope]');
      const form = scope?.querySelector('form.pnw-product-form');
      const buyRow = form?.querySelector('.pnw-product-buyrow');
      if (!(form instanceof HTMLFormElement) || !buyRow) return;

      form.insertBefore(panel, buyRow);
      panel.dataset.pnwAddonReady = 'true';

      const totalElement = panel.querySelector('[data-pnw-addon-total]');
      const errorElement = panel.querySelector('[data-pnw-addon-error]');
      const basePrice = Number(panel.dataset.basePrice || 0);
      const currency = panel.dataset.currency || 'EUR';

      const getAddonQuantity = (card) => {
        const quantityInput = card.querySelector('[data-pnw-addon-quantity]');
        if (quantityInput instanceof HTMLInputElement) {
          const value = Math.max(0, Number.parseInt(quantityInput.value, 10) || 0);
          quantityInput.value = String(value);
          return value;
        }

        const checkbox = card.querySelector('[data-pnw-addon-checkbox]');
        return checkbox instanceof HTMLInputElement && checkbox.checked ? 1 : 0;
      };

      const updateTotal = () => {
        let total = basePrice;
        panel.querySelectorAll('[data-pnw-addon]').forEach((card) => {
          const price = Number(card.dataset.price || 0);
          total += price * getAddonQuantity(card);
          card.classList.toggle('is-selected', getAddonQuantity(card) > 0);
        });
        if (totalElement) totalElement.textContent = formatMoney(total, currency);
      };

      panel.addEventListener('change', updateTotal);
      panel.addEventListener('input', updateTotal);
      updateTotal();

      if (form.dataset.pnwAddonsBound === 'true') return;
      form.dataset.pnwAddonsBound = 'true';

      form.addEventListener('submit', async (event) => {
        const selectedAddons = [];
        panel.querySelectorAll('[data-pnw-addon]').forEach((card) => {
          const quantity = getAddonQuantity(card);
          const variantId = Number.parseInt(card.dataset.variantId || '', 10);
          if (quantity > 0 && Number.isFinite(variantId)) {
            selectedAddons.push({ id: variantId, quantity });
          }
        });

        if (selectedAddons.length === 0) return;

        event.preventDefault();
        if (errorElement) {
          errorElement.hidden = true;
          errorElement.textContent = '';
        }

        const variantField = form.querySelector('[name="id"]');
        const quantityField = form.querySelector('[name="quantity"]');
        const submitButton = form.querySelector('[type="submit"]');
        const mainVariantId = Number.parseInt(variantField?.value || '', 10);
        const mainQuantity = Math.max(1, Number.parseInt(quantityField?.value || '1', 10) || 1);

        if (!Number.isFinite(mainVariantId)) return;

        const items = [
          {
            id: mainVariantId,
            quantity: mainQuantity,
            properties: { _powernet_bundle: panel.dataset.parentProduct || 'Powernet' },
          },
          ...selectedAddons.map((item) => ({
            ...item,
            properties: { _powernet_parent: panel.dataset.parentProduct || 'Powernet' },
          })),
        ];

        if (submitButton instanceof HTMLButtonElement) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ items }),
          });

          const payload = await response.json();
          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || 'Impossibile aggiungere la configurazione al carrello.');
          }

          window.location.assign(`${root}cart`);
        } catch (error) {
          if (errorElement) {
            errorElement.textContent = error instanceof Error ? error.message : 'Impossibile aggiungere la configurazione al carrello.';
            errorElement.hidden = false;
          }
          if (submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
        }
      });
    };

    const setupAllPanels = () => {
      document.querySelectorAll('[data-pnw-addon-panel]').forEach(setupPanel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupAllPanels, { once: true });
    } else {
      setupAllPanels();
    }

    document.addEventListener('shopify:section:load', setupAllPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-product-description-position"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{const scope=document.querySelector('[data-pnw-product-scope]'),meta=scope?.querySelector('.pnw-product-meta'),price=scope?.querySelector('.pnw-product-price'),ds=document.querySelector('[data-pnw-product-description-source]'),vs=document.querySelector('[data-pnw-vat-source]');if(ds&&meta){const d=ds.firstElementChild;if(d&&!d.dataset.moved){meta.insertAdjacentElement('afterend',d);d.dataset.moved='1';ds.remove()}}if(vs&&price){scope.dataset.pnwVatPromoPercent=vs.dataset.promoPercent||'0';scope.dataset.pnwVatRate=vs.dataset.vatRate||'22';const v=vs.firstElementChild;if(v&&!v.dataset.moved){price.insertAdjacentElement('afterend',v);v.dataset.moved='1';vs.remove()}}};const fmt=(c,cur)=>new Intl.NumberFormat('it-IT',{style:'currency',currency:cur||'EUR',minimumFractionDigits:2}).format(c/100);document.addEventListener('change',e=>{const s=e.target.closest?.('[data-pnw-variant-select]');if(!s)return;const scope=s.closest('[data-pnw-product-scope]'),o=s.options[s.selectedIndex],el=scope?.querySelector('[data-pnw-price-ex-vat]');if(!o||!el)return;let p=Number(o.dataset.price||0),q=Number(scope.dataset.pnwVatPromoPercent||0),r=Number(scope.dataset.pnwVatRate||22);if(q>0)p=Math.round(p-p*q/100);el.textContent=fmt(Math.round(p/(1+r/100)),o.dataset.currency)});init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-product-panel-addon"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (amountInCents, currency) => {
      const locale = document.documentElement.lang || 'it-IT';
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR',
      }).format(amountInCents / 100);
    };

    const getQuantity = (card) => {
      const panelInput = card.querySelector('[data-pnw-panel-quantity]');
      if (panelInput instanceof HTMLInputElement) {
        let value = Number.parseInt(panelInput.value, 10) || 0;
        value = Math.max(0, Math.min(4, value));
        panelInput.value = String(value);
        return value;
      }

      const quantityInput = card.querySelector('[data-pnw-addon-quantity]');
      if (quantityInput instanceof HTMLInputElement) {
        return Math.max(0, Number.parseInt(quantityInput.value, 10) || 0);
      }

      const checkbox = card.querySelector('[data-pnw-addon-checkbox]');
      return checkbox instanceof HTMLInputElement && checkbox.checked ? 1 : 0;
    };

    const setup = () => {
      const source = document.querySelector('[data-pnw-panel-addon-source]');
      const addonPanel = document.querySelector('[data-pnw-addon-panel]');
      if (!(source instanceof HTMLElement) || !(addonPanel instanceof HTMLElement)) return;
      if (source.dataset.pnwPanelReady === 'true') return;

      const card = source.querySelector('[data-pnw-addon][data-addon-type="panels"]');
      const grid = addonPanel.querySelector('.pnw-addons__grid');
      const scope = document.querySelector('[data-pnw-product-scope]');
      const form = scope?.querySelector('form.pnw-product-form');
      if (!(card instanceof HTMLElement) || !(grid instanceof HTMLElement) || !(form instanceof HTMLFormElement)) return;

      grid.prepend(card);
      source.hidden = true;
      source.dataset.pnwPanelReady = 'true';

      const panelInput = card.querySelector('[data-pnw-panel-quantity]');
      const totalElement = addonPanel.querySelector('[data-pnw-addon-total]');
      const errorElement = addonPanel.querySelector('[data-pnw-addon-error]');
      const basePrice = Number(addonPanel.dataset.basePrice || 0);
      const currency = addonPanel.dataset.currency || 'EUR';

      const updateTotal = () => {
        if (panelInput instanceof HTMLInputElement) getQuantity(card);
        let total = basePrice;
        addonPanel.querySelectorAll('[data-pnw-addon]').forEach((addonCard) => {
          const quantity = getQuantity(addonCard);
          total += Number(addonCard.dataset.price || 0) * quantity;
          addonCard.classList.toggle('is-selected', quantity > 0);
        });
        if (totalElement) totalElement.textContent = formatMoney(total, currency);
      };

      panelInput?.addEventListener('input', updateTotal);
      panelInput?.addEventListener('change', updateTotal);
      updateTotal();

      form.addEventListener(
        'submit',
        async (event) => {
          const panelQuantity = getQuantity(card);
          if (panelQuantity <= 0) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (errorElement) {
            errorElement.hidden = true;
            errorElement.textContent = '';
          }

          const variantField = form.querySelector('[name="id"]');
          const quantityField = form.querySelector('[name="quantity"]');
          const submitButton = form.querySelector('[type="submit"]');
          const mainVariantId = Number.parseInt(variantField?.value || '', 10);
          const mainQuantity = Math.max(1, Number.parseInt(quantityField?.value || '1', 10) || 1);
          const mountVariantId = Number.parseInt(card.dataset.panelMountVariantId || '', 10);

          if (!Number.isFinite(mainVariantId) || !Number.isFinite(mountVariantId)) return;

          const selectedAddons = [];
          addonPanel.querySelectorAll('[data-pnw-addon]').forEach((addonCard) => {
            const quantity = getQuantity(addonCard);
            if (quantity <= 0) return;
            const variantId = Number.parseInt(addonCard.dataset.variantId || '', 10);
            if (!Number.isFinite(variantId)) return;
            selectedAddons.push({
              id: variantId,
              quantity,
              addonType: addonCard.dataset.addonType || 'optional',
            });
          });

          selectedAddons.push({
            id: mountVariantId,
            quantity: panelQuantity,
            addonType: 'panels-staffaggio',
          });

          const items = [
            {
              id: mainVariantId,
              quantity: mainQuantity,
              properties: { _powernet_bundle: addonPanel.dataset.parentProduct || 'Powernet' },
            },
            ...selectedAddons.map((item) => ({
              id: item.id,
              quantity: item.quantity,
              properties: {
                _powernet_parent: addonPanel.dataset.parentProduct || 'Powernet',
                _powernet_addon: item.addonType,
              },
            })),
          ];

          if (submitButton instanceof HTMLButtonElement) {
            submitButton.disabled = true;
            submitButton.setAttribute('aria-busy', 'true');
          }

          try {
            const root = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
              },
              body: JSON.stringify({ items }),
            });
            const payload = await response.json();
            if (!response.ok || payload.status) {
              throw new Error(payload.description || payload.message || 'Impossibile aggiungere la configurazione al carrello.');
            }
            window.location.assign(`${root}cart`);
          } catch (error) {
            if (errorElement) {
              errorElement.textContent = error instanceof Error ? error.message : 'Impossibile aggiungere la configurazione al carrello.';
              errorElement.hidden = false;
            }
            if (submitButton instanceof HTMLButtonElement) {
              submitButton.disabled = false;
              submitButton.removeAttribute('aria-busy');
            }
          }
        },
        true
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup, { once: true });
    } else {
      setup();
    }

    document.addEventListener('shopify:section:load', setup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-product-quote-request"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{const source=document.querySelector('[data-pnw-quote-source]'),scope=document.querySelector('[data-pnw-product-scope]'),productForm=scope?.querySelector('.pnw-product-form');if(!source||!scope||!productForm)return;if(!source.dataset.pnwMoved){productForm.insertAdjacentElement('afterend',source);source.dataset.pnwMoved='1'}if(source.dataset.pnwQuoteReady==='1')return;source.dataset.pnwQuoteReady='1';const variant=scope.querySelector('[data-pnw-variant-select]'),sku=source.querySelector('[data-pnw-quote-sku]'),productQty=scope.querySelector('input[name="quantity"]'),quoteQty=source.querySelector('[data-pnw-quote-quantity]');const syncSku=()=>{const option=variant?.options[variant.selectedIndex];if(option&&sku)sku.value=option.dataset.sku||''};const syncQty=()=>{if(productQty&&quoteQty&&document.activeElement!==quoteQty)quoteQty.value=productQty.value||'1'};variant?.addEventListener('change',syncSku);productQty?.addEventListener('change',syncQty);syncSku();syncQty()};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();document.addEventListener('shopify:section:load',init)})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-product-social-share"] && !Shopify.designMode) return;
  try {
    
(function(){if(window.__pnwProductSocialShareBound)return;window.__pnwProductSocialShareBound=true;function fallbackCopy(text){var textarea=document.createElement('textarea');textarea.value=text;textarea.setAttribute('readonly','');textarea.style.position='fixed';textarea.style.opacity='0';document.body.appendChild(textarea);textarea.select();var copied=false;try{copied=document.execCommand('copy')}catch(error){copied=false}document.body.removeChild(textarea);return copied}document.addEventListener('click',async function(event){var button=event.target.closest('[data-pnw-copy-share]');if(!button)return;var url=button.getAttribute('data-share-url')||window.location.href;var bar=button.closest('.pnw-social-share__bar');var status=bar?bar.querySelector('[data-pnw-share-status]'):null;var label=button.querySelector('[data-pnw-copy-label]');var copied=false;try{if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(url);copied=true}else{copied=fallbackCopy(url)}}catch(error){copied=fallbackCopy(url)}if(status)status.textContent=copied?'Link copiato negli appunti':'Impossibile copiare il link';if(label&&copied)label.textContent='Copiato';window.setTimeout(function(){if(status)status.textContent='';if(label)label.textContent='Copia link'},2200)})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-sella-financing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (window.__pnwSellaFinancingBound) return;
  window.__pnwSellaFinancingBound = true;

  let observer = null;

  const formatMoney = (amountInCents, currency) => {
    const locale = document.documentElement.lang || 'it-IT';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency || 'EUR',
    }).format(amountInCents / 100);
  };

  const getAddonQuantity = (card) => {
    const panelQuantity = card.querySelector('[data-pnw-panel-quantity]');
    if (panelQuantity instanceof HTMLInputElement) {
      return Math.max(0, Math.min(4, Number.parseInt(panelQuantity.value, 10) || 0));
    }

    const quantityInput = card.querySelector('[data-pnw-addon-quantity]');
    if (quantityInput instanceof HTMLInputElement) {
      return Math.max(0, Number.parseInt(quantityInput.value, 10) || 0);
    }

    const checkbox = card.querySelector('[data-pnw-addon-checkbox]');
    return checkbox instanceof HTMLInputElement && checkbox.checked ? 1 : 0;
  };

  const getContext = () => {
    const source = document.querySelector('[data-pnw-sella-source]');
    const scope = document.querySelector('[data-pnw-product-scope]');
    if (!(source instanceof HTMLElement) || !(scope instanceof HTMLElement)) return null;

    return {
      source,
      scope,
      amount: source.querySelector('[data-pnw-sella-amount]'),
      variant: scope.querySelector('[data-pnw-variant-select]'),
      addonPanel: document.querySelector('[data-pnw-addon-panel]'),
      priceBlock: scope.querySelector('.pnw-product-price-block'),
    };
  };

  const syncAmount = () => {
    const context = getContext();
    if (!context || !context.amount) return;

    const option = context.variant?.options?.[context.variant.selectedIndex];
    if (!option) return;

    let total = Number(option.dataset.price || 0);
    const promoPercent = Math.max(0, Number(context.source.dataset.pnwSellaPromoPercent || 0));
    if (promoPercent > 0) {
      total = Math.round(total - (total * promoPercent) / 100);
    }

    if (context.addonPanel instanceof HTMLElement) {
      context.addonPanel.querySelectorAll('[data-pnw-addon]').forEach((card) => {
        total += Number(card.dataset.price || 0) * getAddonQuantity(card);
      });
    }

    const formatted = formatMoney(total, option.dataset.currency || 'EUR');
    if (context.amount.textContent !== formatted) context.amount.textContent = formatted;
  };

  const placeAfterOptionals = () => {
    const context = getContext();
    if (!context) return;

    if (context.addonPanel instanceof HTMLElement) {
      if (context.source.previousElementSibling !== context.addonPanel) {
        context.addonPanel.insertAdjacentElement('afterend', context.source);
      }
      if (context.addonPanel.closest('form.pnw-product-form') && observer) {
        observer.disconnect();
        observer = null;
      }
    } else if (context.priceBlock instanceof HTMLElement && context.source.previousElementSibling !== context.priceBlock) {
      context.priceBlock.insertAdjacentElement('afterend', context.source);
    }

    syncAmount();
  };

  const queuePlacement = () => {
    requestAnimationFrame(() => requestAnimationFrame(placeAfterOptionals));
  };

  const ensureObserver = () => {
    if (observer || !document.body) return;
    observer = new MutationObserver(() => queuePlacement());
    observer.observe(document.body, { childList: true, subtree: true });
  };

  const start = () => {
    ensureObserver();
    queuePlacement();
  };

  const isRelevantControl = (target) =>
    target instanceof Element &&
    target.matches('[data-pnw-variant-select], [data-pnw-panel-quantity], [data-pnw-addon-quantity], [data-pnw-addon-checkbox]');

  document.addEventListener('input', (event) => {
    if (isRelevantControl(event.target)) syncAmount();
  });

  document.addEventListener('change', (event) => {
    if (isRelevantControl(event.target)) syncAmount();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-social-share-position"]) return;
  try {
    
(function(){
  function moveShareUnderDescription(){
    var host=document.querySelector('.section-pnw-social-share');
    var details=document.querySelector('.pnw-product-details > .pnw-accordion:first-child');
    if(!host||!details)return;
    if(details.nextElementSibling!==host){
      details.insertAdjacentElement('afterend',host);
    }
    host.classList.add('pnw-social-share-host--inline');
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',moveShareUnderDescription,{once:true});
  }else{
    moveShareUnderDescription();
  }
  document.addEventListener('shopify:section:load',moveShareUnderDescription);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-wow-back-link"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const backLink = target.closest('[data-pnw-back-link]');
  if (!backLink) return;

  if (!document.referrer || window.history.length <= 1) return;

  try {
    const referrer = new URL(document.referrer);
    if (referrer.origin !== window.location.origin) return;

    event.preventDefault();
    window.history.back();
  } catch (error) {
    // Il link href resta il fallback.
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-wow-catalog-sync"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const applyCatalogNavigation = () => {
      const host = document.querySelector('[data-pnw-catalog-sync]');
      if (!host) return;

      const megaTemplate = host.querySelector('[data-pnw-catalog-mega-template]');
      const mega = document.querySelector('.pnw-all-categories .pnw-mega');
      if (megaTemplate && mega) {
        mega.replaceChildren(megaTemplate.content.cloneNode(true));
      }

      const desktopTemplate = host.querySelector('[data-pnw-catalog-desktop-template]');
      const desktopNav = document.querySelector('.pnw-nav-links');
      if (desktopTemplate && desktopNav) {
        const saleItem = desktopNav.querySelector('.pnw-nav-sale')?.closest('li');
        desktopNav.replaceChildren(desktopTemplate.content.cloneNode(true));
        if (saleItem) desktopNav.append(saleItem);
      }

      const mobileTemplate = host.querySelector('[data-pnw-catalog-mobile-template]');
      const mobileNav = document.querySelector('.pnw-mobile-links');
      if (mobileTemplate && mobileNav) {
        mobileNav.replaceChildren(mobileTemplate.content.cloneNode(true));
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyCatalogNavigation, { once: true });
    } else {
      applyCatalogNavigation();
    }

    document.addEventListener('shopify:section:load', applyCatalogNavigation);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["powernet-wow-product"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const select = target.closest('[data-pnw-variant-select]');
  if (!select) return;

  const scope = select.closest('[data-pnw-product-scope]');
  if (!scope || scope.dataset.pnwPromoActive !== 'true') return;

  const option = select.options[select.selectedIndex];
  const promoPrice = scope.querySelector('[data-pnw-promo-price]');
  const promoCompare = scope.querySelector('[data-pnw-promo-compare]');

  if (promoPrice && option.dataset.promoPrice) {
    promoPrice.textContent = option.dataset.promoPrice;
  }

  if (promoCompare && option.dataset.promoCompare) {
    promoCompare.textContent = option.dataset.promoCompare;
  }
});

  } catch(e) { console.error(e); }
})();
})();
